class CountdownTimerBar extends HTMLElement {
  constructor() {
    super();
  }

  init() {
    this.date = this.getAttribute("schema-datetime");

    let dateTime = this.parseDate(this.date)?.getTime();
    this.countdown = dateTime;

    this.timer = this.querySelector(".timer");
    this.second = 1000;
    this.minute = this.second * 60;
    this.hour = this.minute * 60;
    this.day = this.hour * 24;

    this.timerInterval = null;
    this.startTimer();

    setTimeout(() => (this.timer.style.display = "block"), 1000);
  }

  parseDate = (date) => {
    // DD-MM-YYYY hh:mm:ss
    const regex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/(\d{4}) ([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/;

    if (!regex.test(date)) {
      throw Error("Invalid date provided. Please follow the given format.");
    }

    const split = date.split(" ");
    const providedDate = split[0].split("/");
    const providedTime = split[1];

    const targetDate = new Date(`${providedDate[2]}-${providedDate[1]}-${providedDate[0]}T${providedTime}`);
    return targetDate;
  };

  padWithLeadingZero = (number) => {
    if (number < 10) {
      return "0" + number;
    } else {
      return number;
    }
  };

  isDateInPast(date) {
    let now = new Date();
    return date < now;
  }

  startTimer() {
    let timerElem = this.timer;
    this.timerInterval = setInterval(() => {
      let now = new Date().getTime();
      let distance = this.countdown - now;

      let dayCalc = Math.max(Math.floor(distance / this.day), 0);
      let hourCalc = Math.max(Math.floor((distance % this.day) / this.hour), 0);
      let minuteCalc = Math.max(Math.floor((distance % this.hour) / this.minute), 0);
      let secondCalc = Math.max(Math.floor((distance % this.minute) / this.second), 0);

      timerElem.querySelector(".js-timer-days").textContent = this.padWithLeadingZero(dayCalc);
      timerElem.querySelector(".js-timer-hours").textContent = this.padWithLeadingZero(hourCalc);
      timerElem.querySelector(".js-timer-minutes").textContent = this.padWithLeadingZero(minuteCalc);
      timerElem.querySelector(".js-timer-seconds").textContent = this.padWithLeadingZero(secondCalc);

      if (dayCalc === 0 && hourCalc === 0 && minuteCalc === 0 && secondCalc === 0) {
        clearInterval(this.timerInterval); // Stop the interval
        let doneMessageElement = document.querySelector("#done-message");
        if (doneMessageElement) {
          doneMessageElement.style.display = "block";
        }
        this.style.display = "none";
      }
    }, this.second);
  }

  disconnectedCallback() {
    clearInterval(this.timerInterval);
    let doneMessageElement = document.querySelector("#done-message");
    if (doneMessageElement) {
      doneMessageElement.style.display = "block";
    }
  }

  connectedCallback() {
    this.init();
    console.log("countdown timer was added to the page");

    let timerFlexContainer = window.document.querySelector(".timer-flex-container");
    let timerElem = this.timer;

    let pastDate = this.isDateInPast(this.countdown);
    if (pastDate) {
      timerFlexContainer.remove();
      this.remove();
    }
    window.setTimeout(() => {
      timerFlexContainer.classList.remove("hide-element");
    }, 2000);
  }


}

customElements.define("countdown-timer-bar", CountdownTimerBar);
